<template>
    <div class="">
        <img class="w-[96px]"
             src="/images/fantastic_logo.png" alt="fantastic">
    </div>
</template>

<script>

</script>
